import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'
import useValidateDashboard from 'DashboardBuilder/hooks/useValidateDashboard'

export default function Preview() {
  const act = useAct()
  const {
    status,
  } = useSel((s) => s.dashboard)

  const finishText = status === 'live' ? 'Save' : 'Launch'
  const [complete, errors] = useValidateDashboard()

  function launch() {
    return act.builder.launch().then(({ data }) => {
      window.location = data.redirectUrl
    })
  }

  return <Step
    name='Preview'
    editor='preview'
    save={launch}
    staticOpenButton={'Preview'}
    finishButtonText={finishText}
    canClickFinish={complete}
    validationErrors={errors}
    showDiscard={false}
    showClose={true}
    shortDescriptor={
      <p className="incomplete no-margin-bottom">Check everything is OK.</p>
    }
  >
    {/* Preview to be added in future here... */}
  </Step>
}
